export function StatusMessage(props: { kind: 'loading' | 'error' | 'empty'; children: string }) {
  if (props.kind === 'loading') {
    return (
      <div className="space-y-2" aria-busy="true" aria-live="polite">
        <div className="h-4 w-40 animate-pulse rounded bg-soft" />
        <div className="h-24 animate-pulse rounded bg-soft" />
        <span className="sr-only">{props.children}</span>
      </div>
    );
  }
  const tone = props.kind === 'error' ? 'border-warn/50 text-warn' : 'border-line text-muted';
  return (
    <p className={`rounded border bg-panel px-3 py-2 text-sm ${tone}`} role={props.kind === 'error' ? 'alert' : 'status'}>
      {props.children}
    </p>
  );
}
